function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}


document.addEventListener('turbo:frame-load', (event) => {
  const { id } = event.target;

  if (id === 'main-product' && window.yotpoWidgetsContainer) {
    window.yotpoWidgetsContainer.initWidgets();
  }

  if (id.startsWith("product-card-") && window.yotpoWidgetsContainer) {
    yotpo.initWidgets()
  }
});

// ChirpFade — global scroll-reveal system (see chirp-fade styles in main.css).
// Elements with .chirp-fade are hidden (only while <html>.chirp-fade-ready is
// set by theme.liquid) and revealed with .chirp-fade-in when scrolled into
// view. Containers with [data-chirp-fade-group] reveal all their .chirp-fade
// descendants together, staggered by --chirp-fade-delay. Containers with
// [data-chirp-fade-children] do the same for their direct children without
// requiring the class on each child (for generic block containers).
(function initChirpFade() {
  if (window.ChirpFade) return;

  const READY_CLASS = 'chirp-fade-ready';
  const REVEAL_CLASS = 'chirp-fade-in';
  const PROCESSED_FLAG = 'chirpFadeObserved';
  const CONTAINER_SELECTOR = '[data-chirp-fade-group], [data-chirp-fade-children]';
  const NON_VISUAL_TAGS = ['STYLE', 'SCRIPT', 'LINK', 'TEMPLATE'];

  const isEnabled = () => document.documentElement.classList.contains(READY_CLASS);

  const globalStagger = () => {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--chirp-fade-stagger');
    const parsed = parseInt(raw, 10);
    return Number.isNaN(parsed) ? 150 : parsed;
  };

  const revealGroup = (container) => {
    const step = parseInt(container.dataset.chirpFadeStagger, 10) || globalStagger();

    let items;
    if (container.hasAttribute('data-chirp-fade-children')) {
      items = Array.from(container.children).filter((el) => (
        !el.classList.contains(REVEAL_CLASS) && !NON_VISUAL_TAGS.includes(el.tagName)
      ));
    } else {
      items = Array.from(container.querySelectorAll(`.chirp-fade:not(.${REVEAL_CLASS})`));
    }

    let autoIndex = 0;
    items.forEach((item) => {
      // An inline --chirp-fade-delay set in markup wins over the auto
      // stagger, letting sections choreograph exact sequences (e.g.
      // closer-look-luxe fades text, then media, then each hotspot).
      if (!item.style.getPropertyValue('--chirp-fade-delay')) {
        item.style.setProperty('--chirp-fade-delay', `${autoIndex * step}ms`);
        autoIndex += 1;
      }
      item.classList.add(REVEAL_CLASS);
    });
  };

  // Targets observed but not yet revealed, so the bottom-of-page fallback
  // below can flush anything the -20% trigger line would otherwise miss.
  const pending = new Set();

  const revealTarget = (target) => {
    pending.delete(target);
    observer.unobserve(target);

    if (target.matches(CONTAINER_SELECTOR)) {
      revealGroup(target);
    } else {
      target.classList.add(REVEAL_CLASS);
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      revealTarget(entry.target);
    });
  // Negative bottom margin delays the trigger until the element is ~20%
  // of the viewport height above the bottom edge, so the animation plays
  // while the element is comfortably in view rather than just entering.
  }, { rootMargin: '0px 0px -20% 0px' });

  // Elements sitting in the last stretch of a page can never cross the
  // -20% trigger line. Once the user is within 10% of a viewport height
  // of the page bottom, reveal everything still pending.
  const checkNearBottom = () => {
    if (pending.size === 0) return;

    const remaining = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
    if (remaining <= window.innerHeight * 0.1) {
      Array.from(pending).forEach(revealTarget);
    }
  };

  let scrollScheduled = false;
  window.addEventListener('scroll', () => {
    if (pending.size === 0 || scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(() => {
      scrollScheduled = false;
      checkNearBottom();
    });
  }, { passive: true });

  const refresh = (root = document) => {
    if (!isEnabled()) return;

    root.querySelectorAll(CONTAINER_SELECTOR).forEach((container) => {
      if (container.dataset[PROCESSED_FLAG]) return;
      container.dataset[PROCESSED_FLAG] = 'true';
      pending.add(container);
      observer.observe(container);
    });

    root.querySelectorAll('.chirp-fade').forEach((el) => {
      if (el.dataset[PROCESSED_FLAG] || el.closest(CONTAINER_SELECTOR)) return;
      el.dataset[PROCESSED_FLAG] = 'true';
      pending.add(el);
      observer.observe(el);
    });

    // Handles pages that load already scrolled to (or near) the bottom,
    // e.g. anchor links, restored scroll positions, or very short pages.
    checkNearBottom();
  };

  window.ChirpFade = { refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh());
  } else {
    refresh();
  }

  // Re-scan after theme editor section re-renders and Turbo frame swaps.
  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
  document.addEventListener('turbo:frame-load', (event) => refresh(event.target));
})();

// Serialize cart mutation requests (helps prevent Shopify 409 conflicts when multiple scripts intercept ATC)
(function patchCartMutationFetchQueue() {
  if (window.__chirpCartMutationFetchPatched) return;
  window.__chirpCartMutationFetchPatched = true;

  const originalFetch = window.fetch.bind(window);
  let chain = Promise.resolve();
  let seq = 0;

  const debugEnabled = (() => {
    try {
      return new URLSearchParams(window.location.search).get('debugCart') === '1';
    } catch (_) {
      return false;
    }
  })();

  const pushDebug = (entry) => {
    if (!debugEnabled) return;
    try {
      if (!window.__chirpCartDebug) window.__chirpCartDebug = [];
      window.__chirpCartDebug.push(entry);
      // keep the last 50 entries
      if (window.__chirpCartDebug.length > 50) {
        window.__chirpCartDebug = window.__chirpCartDebug.slice(-50);
      }
    } catch (_) {}
  };

  const isCartMutation = (url, opts) => {
    if (!opts || !opts.method) return false;
    const method = String(opts.method).toUpperCase();
    if (method !== 'POST') return false;

    const u = typeof url === 'string' ? url : (url && url.url) ? url.url : '';
    if (!u) return false;

    // Shopify cart mutation endpoints (json + non-json)
    return (
      u.includes('/cart/add') ||
      u.includes('/cart/update') ||
      u.includes('/cart/change') ||
      u.includes('/cart/clear')
    );
  };

  window.fetch = function queuedFetch(url, opts) {
    if (!isCartMutation(url, opts)) {
      return originalFetch(url, opts);
    }

    // Queue mutations to avoid concurrent cart writes causing 409
    const id = ++seq;
    const startedQueuedAt = Date.now();
    const u = typeof url === 'string' ? url : (url && url.url) ? url.url : '';

    // Capture a short stack to identify the caller (Proteus vs theme vs other)
    let stack = '';
    if (debugEnabled) {
      try {
        stack = (new Error().stack || '')
          .split('\n')
          .slice(0, 8)
          .join('\n');
      } catch (_) {}
    }

    const run = async () => {
      const startedAt = Date.now();
      const queuedForMs = startedAt - startedQueuedAt;

      if (debugEnabled) {
        console.groupCollapsed(`[cart-mutation #${id}] START ${u} (queued ${queuedForMs}ms)`);
        console.log('opts', opts);
        if (stack) console.log('stack', stack);
        console.groupEnd();
      }
      pushDebug({
        id,
        phase: 'start',
        url: u,
        method: (opts && opts.method) || 'POST',
        queuedForMs,
        at: startedAt,
        stack
      });

      try {
        const res = await originalFetch(url, opts);
        const endedAt = Date.now();

        if (debugEnabled) {
          console.info(`[cart-mutation #${id}] END ${u} -> ${res.status} (${endedAt - startedAt}ms)`);
        }
        pushDebug({
          id,
          phase: 'end',
          url: u,
          status: res.status,
          ok: res.ok,
          tookMs: endedAt - startedAt,
          at: endedAt
        });

        return res;
      } catch (err) {
        const endedAt = Date.now();
        if (debugEnabled) {
          console.warn(`[cart-mutation #${id}] ERROR ${u} (${endedAt - startedAt}ms)`, err);
        }
        pushDebug({
          id,
          phase: 'error',
          url: u,
          tookMs: endedAt - startedAt,
          at: endedAt,
          message: String(err && err.message ? err.message : err)
        });
        throw err;
      }
    };
    const p = chain.then(run, run);
    // Ensure the chain continues even if this request fails
    chain = p.catch(() => {});
    return p;
  };
})();

class CartManager {

  static async fetchCart({ signal } = {}) {
    const res = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      signal
    });
    if (!res.ok) {
      throw new Error(`Failed to fetch cart.js (${res.status})`);
    }
    return await res.json();
  }

  static async waitForCartContains({ variantId, minItemCount, timeoutMs = 4000 } = {}) {
    const start = Date.now();
    let delay = 150;

    // Ensure variantId is a number when comparing to Shopify cart JSON
    const wantedVariantId = variantId != null ? Number(variantId) : null;

    while (Date.now() - start < timeoutMs) {
      try {
        const cart = await this.fetchCart();
        const hasVariant = wantedVariantId == null
          ? true
          : cart.items?.some((i) => Number(i.variant_id) === wantedVariantId);
        const hasCount = minItemCount == null ? true : (cart.item_count >= minItemCount);

        if (hasVariant && hasCount) return cart;
      } catch (_) {
        // ignore transient errors and retry until timeout
      }

      await new Promise((r) => setTimeout(r, delay));
      delay = Math.min(700, Math.round(delay * 1.6));
    }

    // One last attempt to provide the latest cart (even if it doesn't match expectations)
    try {
      return await this.fetchCart();
    } catch (_) {
      return null;
    }
  }

  static reloadMainCart() {
    if (window.location.pathname == '/cart') {
      window.location.reload();
      return;
    }
    const mainCart = document.getElementById('frame-main-cart');
    if (mainCart) mainCart.reload();
  }

  static reloadCartCount() {
    const cartCount = document.getElementById('frame-cart-count');
    if (cartCount) cartCount.reload();
  }

  static async refreshCartUI({ variantId, minItemCount } = {}) {
    const cart = await this.waitForCartContains({ variantId, minItemCount });
    this.reloadCartCount();
    this.reloadMainCart();
    if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return cart;
  }


  static openCart() {
    const cartLink = document.getElementById('cart-link');
    if (cartLink) cartLink.click();
  }

  static async update(updates) {
    try {
      const cart = await fetch('/cart.js').then(res => res.json());
      const mergedUpdates = { ...updates };

      const updatedLineKey = Object.keys(updates)[0];
      const newQty = updates[updatedLineKey];

      const updatedItem = cart.items.find(item => item.key === updatedLineKey);

      if (updatedItem && updatedItem.properties && updatedItem.properties._ApplyGift) {
        const giftVariantId = updatedItem.properties._ApplyGift;
  
        const giftItem = cart.items.find(
          (item) => item.properties && item.properties._Gift === giftVariantId
        );
  
        if (giftItem) {
          mergedUpdates[giftItem.key] = newQty;
        } else {
          mergedUpdates[giftVariantId] = newQty;
        }
      }

      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: mergedUpdates }),
      });

      this.reloadCartCount();
      this.reloadMainCart();
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

}



/**
 * Base component class that implements common functionality
 * for all components
 */
class BaseComponent extends HTMLElement {
  constructor() {
    super();
    this._boundEvents = new Map();
    this.debug = false; // Toggle debug mode
  }

  addSafeEventListener(element, event, handler) {
    if (!element) return;
    const boundHandler = handler.bind(this);
    element.addEventListener(event, boundHandler);
    if (!this._boundEvents.has(element)) {
      this._boundEvents.set(element, []);
    }
    this._boundEvents.get(element).push({ event, handler: boundHandler });
  }

  disconnectedCallback() {
    this._boundEvents.forEach((events, element) => {
      events.forEach(({ event, handler }) => {
        element.removeEventListener(event, handler);
      });
    });
    this._boundEvents.clear();
  }

  findClosest(selector) {
    return this.closest(selector);
  }


  toggleVisibility(element, show) {
    element.classList.toggle('hidden', !show);
  }

  log(message, data = null, type = 'log') {
    if (!this.debug) return;
    console[type](message, data);
  }

}



customElements.define('video-component', class VideoComponent extends BaseComponent {

  constructor() {
    super();
    this.video = this.querySelector('video');
    this.toggle = this.querySelector('[data-video-toggle]');

    this.playSVG = this.querySelector('[data-play-svg]');
    this.pauseSVG = this.querySelector('[data-pause-svg]');

    if (this.playSVG) this.video.removeAttribute("controls");
  }

  connectedCallback() {
    if (this.video && !this.video.autoplay) {
      this.playSVG.classList.remove('hidden');
      this.pauseSVG.classList.add('hidden');
    }

    this.addSafeEventListener(this.toggle, 'click', this.toggleVideo);
  }

  toggleVideo(event) {
    event.preventDefault();
    if (this.video.paused) {
      this.video.play();
      this.playSVG.classList.add('hidden');
      this.pauseSVG.classList.remove('hidden');
    } else {
      this.video.pause();
      this.playSVG.classList.remove('hidden');
      this.pauseSVG.classList.add('hidden');
    }
  }
});

customElements.define('deferred-video', class DeferredVideo extends BaseComponent {
  constructor() {
    super();
    this.loaded = false;
    this.video = null;
    this.toggle = this.querySelector('[data-video-toggle]');
    this.playSVG = this.querySelector('[data-play-svg]');
    this.pauseSVG = this.querySelector('[data-pause-svg]');
  }

  connectedCallback() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loaded) {
          this.loadVideo();
          this.loaded = true;
          observer.disconnect();
        }
      });
    });
    observer.observe(this);
  }

  loadVideo() {
    const poster = this.querySelector('.lazy-poster');
    const video = document.createElement('video');
  
    // Basic attributes
    video.className = "cjs-media__video w-full h-full object-cover";
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    
    // Set poster attribute if available
    if (this.dataset.poster) {
      video.poster = this.dataset.poster;
    }
    
    // Conditionally set muted based on autoplay setting
    const shouldAutoplay = this.dataset.autoplay === 'true';
    video.muted = shouldAutoplay; // Mute only if autoplaying
    
    video.loop = true;
    video.preload = "metadata"; // only loads metadata & first frame
    video.controls = false; // hide native controls (optional)
  
    // Add source
    if (this.dataset.srcMp4) {
      const s = document.createElement('source');
      s.src = this.dataset.srcMp4;
      s.type = "video/mp4";
      video.appendChild(s);
    }
  
    // Keep poster visible, append hidden video
    video.style.opacity = '0';
    video.style.transition = 'opacity 220ms ease';
    video.style.position = 'absolute';
    video.style.inset = '0';
    video.style.width = '100%';
    video.style.height = '100%';
    video.style.objectFit = 'cover';
    video.style.display = 'block';
    video.style.willChange = 'opacity, transform';
  
    if (poster && poster.parentNode) {
      poster.parentNode.insertBefore(video, poster.nextSibling);
    } else {
      this.appendChild(video);
    }
  
    this.video = video;
  
    // Wait for first frame, then fade in video
    const onLoaded = () => {
      // Trigger reflow
      video.offsetHeight;
      requestAnimationFrame(() => {
        video.style.transform = 'translateZ(0)';
        video.style.opacity = '1';
  
        setTimeout(() => {
          video.style.transform = '';
          video.style.willChange = '';
        }, 300);
  
        setTimeout(() => {
          if (poster && poster.parentNode) poster.parentNode.removeChild(poster);
        }, 250);
      });
  
      video.removeEventListener('loadeddata', onLoaded);
    };
  
    video.addEventListener('loadeddata', onLoaded);
  
    // Controls UI (no autoplay here)
    if (this.playSVG && this.pauseSVG) {
      video.addEventListener('play', () => {
        this.playSVG.classList.add('hidden');
        this.pauseSVG.classList.remove('hidden');
      });
  
      video.addEventListener('pause', () => {
        this.playSVG.classList.remove('hidden');
        this.pauseSVG.classList.add('hidden');
      });
    }
  
    const videoControls = this.querySelector('.video-controls');
    if (videoControls) {
      const showControls = () => {
        videoControls.classList.remove('hidden', 'opacity-0', 'pointer-events-none');
        clearTimeout(this.pauseTimeout);
        this.pauseTimeout = setTimeout(() => {
          if (!video.paused) videoControls.classList.add('opacity-0', 'pointer-events-none');
        }, 500);
      };
      video.addEventListener('play', showControls);
      video.addEventListener('pause', () => {
        videoControls.classList.remove('opacity-0', 'pointer-events-none');
      });
      ['mousemove', 'touchstart'].forEach(evt => video.addEventListener(evt, showControls));
    }

    if (this.video && !this.video.autoplay) {
      this.playSVG.classList.remove('hidden');
      this.pauseSVG.classList.add('hidden');
    }
  
    if (this.toggle) {
      this.toggle.addEventListener('click', (e) => this.toggleVideo(e));
    }
  
    this.dispatchEvent(new CustomEvent('video-loaded', { bubbles: true }));
  }  

  toggleVideo(event) {
    event.preventDefault();
    if (!this.video) return;

    if (this.video.paused) this.video.play();
    else this.video.pause();
  }
});

customElements.define('product-form', class ProductForm extends BaseComponent {

  constructor() {
    super();
    this.form = this.querySelector('form');
    this.button = this.querySelector('button[type="submit"]');
    //this.quantityInput = this.querySelector('input[name="quantity"]');
    this._submitting = false;
  }

  connectedCallback() {
    this.addSafeEventListener(this.form, 'submit', this.handleSubmit);

  }

  setButtonLoading(isLoading) {
    if (!this.button) return;

    const isQuickAdd = this.button.classList.contains('quick-add__button');

    // Store original text if not already stored
    if (!this.button.dataset.originalText) {
      this.button.dataset.originalText = this.button.innerHTML;
    }

    if (isLoading) {
      this.button.disabled = true;
      this.button.classList.add('opacity-50', 'cursor-not-allowed');
      if (isQuickAdd) {
        this.button.querySelector('.add-to-cart-text').innerHTML = "Adding...";
      } else {
        this.button.innerHTML = "Adding...";
      }
    } else {
      this.button.disabled = false;
      this.button.classList.remove('opacity-50', 'cursor-not-allowed');
      this.button.innerHTML = this.button.dataset.originalText;
    }
  }

  handleSubmit = async (event) => {
    event?.preventDefault();
    if (this._submitting) return;
    this._submitting = true;

    const openCart = this.dataset.openCart || 'true';
    this.setButtonLoading(true);

    const mainVariantId = this.form.querySelector('input[name="id"]').value;
    const quantityInput = this.form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    const promoGiftInput = this.form.querySelector('#promo_gift');
    const promoGiftId = promoGiftInput ? promoGiftInput.value : null;

    try {
      let beforeCart = null;
      try {
        beforeCart = await CartManager.fetchCart();
      } catch (_) {}

      let formData = {
        items: [
          {
            id: mainVariantId,
            quantity: quantity,
            properties: {}
          }
        ]
      };

      // Collect all properties from the form and append them as properties of items[0]
      const propertyInputs = this.form.querySelectorAll('input[name^="properties["]');
      propertyInputs.forEach((input) => {
        const propertyName = input.name.match(/properties\[(.*?)\]/)[1];
        formData.items[0].properties[propertyName] = input.value;
      });

      // If no gift yet, also add the gift
      if (promoGiftId) {
        formData.items[0].properties._ApplyGift = promoGiftId;

        // Add the gift item
        formData.items.push({
          id: promoGiftId,
          quantity: 1,
          properties: {
            _Gift: promoGiftId
          }
        });
      }

      // Submit as JSON (retry 409 Conflict, which can occur under concurrent cart mutations)
      const postAddWithRetry = async ({ retries = 2 } = {}) => {
        let attempt = 0;
        while (true) {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(formData),
          });

          if (response.status === 409 && attempt < retries) {
            attempt += 1;
            await new Promise((r) => setTimeout(r, 250 * attempt));
            continue;
          }

          return response;
        }
      };

      const response = await postAddWithRetry();

      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        const msg = result?.description || result?.message || `Add to cart failed (${response.status})`;
        throw new Error(msg);
      }

      // MAI Add to Cart Tracking
      if (typeof MAI !== 'undefined' && result.items && result.items[0]) {
        const item = result.items[0];
        MAI.emit('addToCart', item.price / 100, item.price_currency || 'USD', item.quantity, {
          productId: String(item.product_id),
          productName: item.product_title,
          productType: item.product_type,
          productVendor: item.vendor,
          variantId: String(item.variant_id),
          variantName: item.variant_title
        });
      }

      const minItemCount = (beforeCart?.item_count ?? 0) + quantity;
      await CartManager.refreshCartUI({ variantId: mainVariantId, minItemCount });
      if (openCart == 'true') CartManager.openCart();

    } catch (error) {
      console.error('Error:', error);
    } finally {
      this.setButtonLoading(false);
      this._submitting = false;
    }
  };
});


class KeyboardManager {

  constructor(component) {
    this.component = component;
    this.lastActiveElement = null;
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
  }


  engage() {
    this.lastActiveElement = document.activeElement;
    document.addEventListener('keydown', this.onKeyDown);
    //document.addEventListener('keyup', this.onKeyUp);
    
    // Calculate scrollbar width and add padding to prevent layout shift
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
    
    document.querySelector('body').style.overflow = 'hidden';

    requestAnimationFrame(() => this.focusFirstElement());
  }


  disengage() {
    document.removeEventListener('keydown', this.onKeyDown);
    //document.removeEventListener('keyup', this.onKeyUp);
    
    // Remove padding and restore overflow
    document.body.style.paddingRight = '';
    document.querySelector('body').style.overflow = '';

    // Restore previous focus
    if (this.lastActiveElement) {
      this.lastActiveElement.focus();
      this.lastActiveElement = null;
    }

  }

  onKeyUp(event) {
    if (event.key === 'Tab') console.log(document.activeElement);
  }


  onKeyDown(event) {
    if (event.key === 'Escape' && typeof this.component.close === 'function') {
      this.component.close();
      return;
    }

    if (event.key === 'Tab') {
      this.handleTabKey(event);

    }
  }

  handleTabKey(event) {

    const focusableElements = this.getFocusableElements();

    if (!focusableElements.length) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }


  getFocusableElements() {
    return Array.from(this.component.querySelectorAll(
      "summary, a, button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )).filter(el => this.isElementFocusable(el));
  }

  focusFirstElement() {
    const focusableElements = this.getFocusableElements();
    if (focusableElements.length) focusableElements[0].focus();
  }



  isElementFocusable(element) {
    if (!element || element.hasAttribute('disabled') || element.hasAttribute('hidden')) {
      return false;
    }

    return true;

    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);

  }

  destroy() {
    this.disengage();
  }
}




/**
 * Base class for components that need to handle toggling states
 */
class ToggleComponent extends BaseComponent {

  constructor() {
    super();
    this.trigger = this.querySelector('[data-trigger]');
    this.content = this.querySelector('[data-content]');
    this.overlay = this.querySelector('[data-overlay]');
    this.closeBtns = this.querySelectorAll('[data-close]');
  }

  connectedCallback() {
    if (!this.trigger || !this.overlay) return;

    this.keyboardManager = new KeyboardManager(this);

    this.addSafeEventListener(this.trigger, 'click', this.toggle);
    this.closeBtns.forEach(btn => this.addSafeEventListener(btn, 'click', this.close));

  }


  toggle(event) {
    event?.preventDefault();
    this.isOpen() ? this.close(event) : this.open(event);
  }


  open(event) {
    event?.preventDefault();
    this.trigger?.setAttribute('aria-expanded', 'true');
    this.toggleVisibility(this.overlay, true);

    if (this.hasAttribute('trap-focus')) this.keyboardManager.engage();
    if (this.hasAttribute('close-on-click')) document.addEventListener('click', this.handleOutsideClick.bind(this));

  }

  handleOutsideClick(event) {

    if (!this.isOpen()) return;

    const isOutsideClick = !this.content?.contains(event.target) && !this.trigger?.contains(event.target);

    if (isOutsideClick) this.close();
  }


  close(event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.trigger?.setAttribute('aria-expanded', 'false');
    this.toggleVisibility(this.overlay, false);

    if (this.hasAttribute('trap-focus')) this.keyboardManager.disengage();
    if (this.hasAttribute('close-on-click')) document.removeEventListener('click', this.handleOutsideClick.bind(this));
  }


  isOpen() {
    return this.trigger?.getAttribute('aria-expanded') === 'true';
  }


  disconnectedCallback() {
    super.disconnectedCallback();
    this.keyboardManager.destroy();
  }

}

customElements.define('toggle-component', ToggleComponent);

customElements.define('modal-component', class ModalComponent extends ToggleComponent {
  constructor() {
    super();
  }

});


customElements.define('video-modal', class VideoModal extends ToggleComponent {

  constructor() {
    super();
    this.video = this.querySelector('video');
  }

  open() {
    // Ensure overlay is positioned relative to viewport, not parent
    if (this.overlay) {
      // Move overlay to body temporarily to break out of any containing blocks
      const originalParent = this.overlay.parentNode;
      document.body.appendChild(this.overlay);
      this._originalParent = originalParent;
    }
    
    // Find and hide the video-list-slider parent
    const videoListSlider = this.closest('video-list-slider');
    if (videoListSlider) {
      videoListSlider.style.opacity = '0';
    }
    
    super.open();
    if (this.video) {
      this.video.play();
    }
  }

  close() {
    super.close();
    if (this.video) {
      this.video.pause();
    }
    
    // Move overlay back to original position
    if (this.overlay && this._originalParent) {
      this._originalParent.appendChild(this.overlay);
      this._originalParent = null;
    }
    
    // Show the video-list-slider parent again
    const videoListSlider = this.closest('video-list-slider');
    if (videoListSlider) {
      videoListSlider.style.opacity = '1';
    }
  }
});




customElements.define('drawer-component', class DrawerComponent extends ToggleComponent {

  constructor() {
    super();
    this.trigger = document.querySelector(this.getAttribute('trigger'));
  }

  open() {
    super.open();

    setTimeout(() => {
      this.content.classList.remove('translate-x-full');
    }, 100);

  }

  close() {
    this.content.classList.add('translate-x-full');

    setTimeout(() => {
      super.close();
    }, 700);
  }

});




customElements.define('tab-component', class TabComponent extends ToggleComponent {

  constructor() {
    super();
    this.tabs = this.closest('.shopify-section').querySelectorAll('tab-component');
  }

  open() {

    this.tabs.forEach(tab => {
      if (tab !== this && tab.isOpen()) tab.close();
    });

    super.open();
  }
});


// Accordion with eased expand/collapse. Same markup contract as
// toggle-component ([data-trigger] + [data-overlay]) but animates the
// overlay's height (and its vertical padding, which border-box sizing
// would otherwise leave visible at height: 0) instead of snapping.
customElements.define('accordion-component', class AccordionComponent extends ToggleComponent {

  get reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  open(event) {
    if (!this.overlay || this.reduceMotion) {
      super.open(event);
      return;
    }

    // If we're interrupting a close animation, start from the current
    // rendered height instead of 0.
    const wasHidden = this.overlay.classList.contains('hidden');
    const fromHeight = wasHidden ? 0 : this.overlay.getBoundingClientRect().height;

    super.open(event);
    this._cancelAnimation();

    const cs = getComputedStyle(this.overlay);
    this._animate(
      { height: `${fromHeight}px`, paddingTop: '0px', paddingBottom: '0px' },
      { height: `${this.overlay.scrollHeight}px`, paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom }
    );
  }

  close(event) {
    if (!this.overlay || this.reduceMotion || this.overlay.classList.contains('hidden')) {
      super.close(event);
      return;
    }

    event?.preventDefault();
    event?.stopPropagation();

    const fromHeight = this.overlay.getBoundingClientRect().height;
    const cs = getComputedStyle(this.overlay);
    const fromPadTop = cs.paddingTop;
    const fromPadBottom = cs.paddingBottom;
    this._cancelAnimation();

    this.trigger?.setAttribute('aria-expanded', 'false');
    this._animate(
      { height: `${fromHeight}px`, paddingTop: fromPadTop, paddingBottom: fromPadBottom },
      { height: '0px', paddingTop: '0px', paddingBottom: '0px' },
      () => this.toggleVisibility(this.overlay, false)
    );
  }

  _animate(from, to, onFinish) {
    this.overlay.style.overflow = 'hidden';
    this._heightAnim = this.overlay.animate([from, to], {
      duration: 350,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
    });
    this._heightAnim.onfinish = () => {
      this._heightAnim = null;
      this.overlay.style.overflow = '';
      if (onFinish) onFinish();
    };
  }

  _cancelAnimation() {
    if (this._heightAnim) {
      this._heightAnim.onfinish = null;
      this._heightAnim.cancel();
      this._heightAnim = null;
      this.overlay.style.overflow = '';
    }
  }
});



customElements.define('content-cycle', class ContentCycle extends BaseComponent {

  constructor() {
    super();
    this.contents = this.querySelectorAll('[data-content]');
    this.interval = null;
    this.activeIndex = 0;
    this.speed = parseInt(this.getAttribute('data-speed')) || 5000;
  }

  connectedCallback() {
    this.addSafeEventListener(this, 'mouseover', this.focusInHandling);
    this.addSafeEventListener(this, 'mouseleave', this.focusOutHandling);

    this.play();
  }

  disconnectedCallback() {
    this.stop();
    super.disconnectedCallback();
  }

  play() {

    if (this.contents.length < 2) return;

    this.interval = setInterval(() => {

      const nextIndex = this.activeIndex === (this.contents.length - 1) ? 0 : this.activeIndex + 1

      this.toggleVisibility(this.contents[this.activeIndex], false);
      this.toggleVisibility(this.contents[nextIndex], true);

      this.activeIndex = nextIndex;

    }, this.speed);
  }


  stop() {
    clearInterval(this.interval);
  }

  focusOutHandling(event) {
    this.play();
  }

  focusInHandling(event) {
    this.stop();
  }

});


/**
* SubscriptionBox Component
* Handles subscription and one-time purchase options for products
*/
customElements.define('subscription-box', class SubscriptionBox extends BaseComponent {
  connectedCallback() {
    this.variantId = this.dataset.variantId;
    this.planDefault = this.dataset.planDefault;

    this.purchaseOptions = this.querySelectorAll(`[name="purchase-type-${this.variantId}"]`);
    this.planSelector = this.querySelector('[data-plan-selector]');
    this.planWrapper = this.querySelector('[data-plan-wrapper]');

    if (!this.purchaseOptions.length || !this.planSelector || !this.planWrapper) {
      console.warn('Subscription box missing required elements');
      return;
    }

    this.setupEventListeners();
    this.initializeState();
  }

  setupEventListeners() {
    this.purchaseOptions.forEach(option => {
      this.addSafeEventListener(option, 'change', this.handlePurchaseTypeChange);
    });
  }

  initializeState() {
    // Check if any option is pre-selected
    const selectedOption = Array.from(this.purchaseOptions)
      .find(option => option.checked);

    if (selectedOption) {
      this.updatePlanVisibility(selectedOption.value);
    }
  }

  handlePurchaseTypeChange = (event) => {
    this.updatePlanVisibility(event.target.value);
  }

  updatePlanVisibility(purchaseType) {
    if (purchaseType === 'otp') {
      this.planWrapper.style.display = 'none';
      this.planSelector.value = '';
    } else if (purchaseType === 'subscription') {
      this.planWrapper.style.display = 'block';
      this.planSelector.value = this.planDefault;
    }
  }
});


/**
* Enhanced Layout Component with improved sliding functionality
*/
/**
 * Enhanced Layout Component with Debug
 */
customElements.define('cjs-layout', class CJSLayout extends BaseComponent {
  constructor() {
    super();
    this._scrollAmount = 0;
    this.resizeObserver = null;

    this.log('Constructor initialized');
  }


  connectedCallback() {
    this.log('Component connecting...');

    try {
      this.track = this.querySelector('[data-cjs-track]');
      this.prev = this.querySelector('[data-cjs-prev]');
      this.next = this.querySelector("[data-cjs-next]");


      if (!this.track || !this.prev || !this.next) {
        this.logError('Required elements missing', {
          track: !!this.track,
          prev: !!this.prev,
          next: !!this.next
        });
        return;
      }

      // Get scroll configuration from data attributes
      this.scrollBy = this.getAttribute('data-scroll-by') || 'item';
      this.scrollBehavior = this.getAttribute('data-scroll-behavior') || 'smooth';

      this.log('Configuration', {
        scrollBy: this.scrollBy,
        scrollBehavior: this.scrollBehavior,
        trackWidth: this.track.scrollWidth,
        visibleWidth: this.track.clientWidth
      });

      this.setupNavigation();
      this.setupScrollListener();
      this.setupResizeObserver();

      // Initial state update
      this.updateButtonStates();
    } catch (error) {
      this.log('Error in connectedCallback', error, 'error');
    }
  }

  disconnectedCallback() {
    this.log('Component disconnecting...');
    try {
      super.disconnectedCallback();
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    } catch (error) {
      this.log('Error in disconnectedCallback', error);
    }
  }

  setupResizeObserver() {
    this.log('Setting up ResizeObserver');
    try {
      this.resizeObserver = new ResizeObserver((entries) => {
        this.log('Resize detected', {
          contentRect: entries[0].contentRect
        });
        this.updateButtonStates();
      });
      this.resizeObserver.observe(this.track);
    } catch (error) {
      this.log('Error setting up ResizeObserver', error);
    }
  }

  setupScrollListener() {
    this.log('Setting up scroll listener');
    let scrollTimeout;
    this.addSafeEventListener(this.track, 'scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const metrics = this.getScrollMetrics();
        this.log('Scroll event fired', metrics);
        requestAnimationFrame(() => this.updateButtonStates());
      }, 150);
    });
  }

  setupNavigation() {
    this.log('Setting up navigation buttons');
    this.addSafeEventListener(this.prev, 'click', (e) => {
      e.preventDefault();
      const canScroll = this.canScrollPrev();
      this.log('Previous button clicked', { canScroll });
      if (canScroll) {
        this.scrollPrev();
      }
    });

    this.addSafeEventListener(this.next, 'click', (e) => {
      e.preventDefault();
      const canScroll = this.canScrollNext();
      this.log('Next button clicked', { canScroll });
      if (canScroll) {
        this.scrollNext();
      }
    });
  }

  getScrollMetrics() {
    const { scrollLeft, clientWidth, scrollWidth } = this.track;
    let itemWidth = 0;

    if (this.scrollBy === 'item') {
      // Get all content elements, excluding style tags and text nodes
      const contentElements = Array.from(this.track.children).filter(
        child => child.nodeType === 1 && child.tagName !== 'STYLE'
      );

      if (contentElements.length > 0) {
        itemWidth = contentElements[0].offsetWidth;
      }
    }

    return {
      scrollLeft,
      clientWidth,
      scrollWidth,
      itemWidth
    };
  }

  canScrollPrev() {
    const { scrollLeft } = this.getScrollMetrics();
    const canScroll = scrollLeft > 0;
    this.log('Can scroll previous?', { canScroll, scrollLeft });
    return canScroll;
  }

  canScrollNext() {
    const { scrollLeft, clientWidth, scrollWidth } = this.getScrollMetrics();
    const canScroll = scrollLeft + clientWidth < scrollWidth;
    this.log('Can scroll next?', {
      canScroll,
      scrollLeft,
      clientWidth,
      scrollWidth,
      remaining: scrollWidth - (scrollLeft + clientWidth)
    });
    return canScroll;
  }

  calculateScrollAmount() {
    const { clientWidth, itemWidth } = this.getScrollMetrics();
    return this.scrollBy === 'item' ? itemWidth : clientWidth;
  }

  scrollPrev() {
    if (!this.track) {
      this.log('Track element missing', null, 'error');
      return;
    }

    const scrollAmount = this.calculateScrollAmount();
    if (scrollAmount === 0) {
      this.log('Scroll amount is 0, cannot scroll', null, 'error');
      return;
    }

    const currentScroll = this.track.scrollLeft;
    const targetScroll = Math.max(0, currentScroll - scrollAmount);

    this.log('Scrolling previous', {
      from: currentScroll,
      by: -scrollAmount,
      to: targetScroll
    });

    requestAnimationFrame(() => {
      this.track.scrollTo({
        left: targetScroll,
        behavior: this.scrollBehavior
      });
    });
  }

  scrollNext() {
    if (!this.track) {
      this.log('Track element missing', null, 'error');
      return;
    }

    const scrollAmount = this.calculateScrollAmount();
    if (scrollAmount === 0) {
      this.logError('Scroll amount is 0, cannot scroll');
      return;
    }

    const { scrollLeft, clientWidth, scrollWidth } = this.getScrollMetrics();
    const maxScroll = scrollWidth - clientWidth;
    const targetScroll = Math.min(maxScroll, scrollLeft + scrollAmount);

    this.log('Scrolling next', {
      from: scrollLeft,
      by: scrollAmount,
      to: targetScroll,
      maxScroll,
      scrollWidth,
      clientWidth
    });

    requestAnimationFrame(() => {
      this.track.scrollTo({
        left: targetScroll,
        behavior: this.scrollBehavior
      });
    });
  }

  updateButtonStates() {
    try {
      const canScrollPrev = this.canScrollPrev();
      const canScrollNext = this.canScrollNext();

      this.log('Updating button states', {
        canScrollPrev,
        canScrollNext,
        metrics: this.getScrollMetrics()
      });

      this.updateButtonState(this.prev, canScrollPrev);
      this.updateButtonState(this.next, canScrollNext);

      this.dispatchEvent(new CustomEvent('scroll-state-change', {
        detail: { canScrollPrev, canScrollNext }
      }));
    } catch (error) {
      this.log('Error updating button states', error, 'error');
    }
  }

  updateButtonState(button, canScroll) {
    try {
      const buttonType = button === this.prev ? 'prev' : 'next';
      this.log(`Updating ${buttonType} button state`, { canScroll });

      // Update button classes and state
      button.classList.toggle('opacity-50', !canScroll);
      button.classList.toggle('cursor-not-allowed', !canScroll);
      button.setAttribute('aria-disabled', (!canScroll).toString());
      button.disabled = !canScroll;
    } catch (error) {
      this.log('Error updating button state', error, 'error');
    }
  }
});


customElements.define('media-component', class MediaComponent extends BaseComponent {

  constructor() {
    super();

  }


  connectedCallback() {

    this.poster = this.querySelector('a');

    if (!this.poster) return;

    this.template = this.querySelector('template');

    this.addSafeEventListener(this.poster, 'click', this.loadContent.bind(this));

  }


  loadContent(event) {

    //window.pauseAllMedia();

    event.preventDefault();

    if (!this.getAttribute('loaded')) {

      const content = document.createElement('div');

      const newNode = this.template.content.firstElementChild.cloneNode(true);

      content.appendChild(newNode);

      this.setAttribute('loaded', true);

      const media = content.querySelector('video, model-viewer, iframe')

      this.poster.appendChild(media).focus();

    }
  }


  pauseAllMedia() {
    const videos = document.querySelectorAll('video');
    videos.forEach((video) => video.pause());
  }

})

/**
 * CJSMedia Component
 * Handles lazy loading of media content (video, model-viewer, iframe)
 * with automatic video pause when hidden
 */
customElements.define('cjs-media', class CJSMedia extends BaseComponent {
  constructor() {
    super();
    this.observer = null;
    this.mediaElement = null;
  }

  connectedCallback() {
    this.poster = this.querySelector('a');
    this.template = this.querySelector('template');

    if (!this.poster || !this.template) {
      console.warn('CJS Media: Missing required elements (poster or template)');
      return;
    }

    this.addSafeEventListener(this.poster, 'click', this.loadContent);

    // Setup intersection observer for visibility changes
    this.setupVisibilityObserver();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.observer) {
      this.observer.disconnect();
    }
    this.stopMedia();
  }

  setupVisibilityObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.stopMedia();
        }
      });
    }, {
      threshold: 0
    });

    this.observer.observe(this);
  }

  loadContent = (event) => {
    event.preventDefault();

    if (this.hasAttribute('loaded')) return;

    try {
      // Create container for the new content
      const content = document.createElement('div');

      // Clone the template content
      const mediaContent = this.template.content.firstElementChild.cloneNode(true);

      // Add the cloned content to the container
      content.appendChild(mediaContent);

      // Find the media element
      const media = content.querySelector('video, model-viewer, iframe');

      if (!media) {
        console.warn('CJS Media: No valid media element found in template');
        return;
      }

      // Store reference to media element
      this.mediaElement = media;

      // Insert the media before the poster
      const insertedMedia = this.insertBefore(media, this.poster);

      // Remove the poster
      this.poster.remove();

      // Mark as loaded
      this.setAttribute('loaded', '');

      // Focus and play if it's a video
      insertedMedia.focus();
      if (this.isVideo()) {
        insertedMedia.play();
      }

      // Add visibility change listener
      this.addSafeEventListener(this, 'visibilitychange', () => {
        if (document.hidden) {
          this.stopMedia();
        }
      });
    } catch (error) {
      console.error('CJS Media: Error loading content', error);
    }
  }

  isVideo() {
    return this.mediaElement instanceof HTMLVideoElement;
  }

  stopMedia() {
    if (this.mediaElement && this.isVideo()) {
      try {
        this.mediaElement.pause();
        // Reset video to start
        this.mediaElement.currentTime = 0;
      } catch (error) {
        console.warn('CJS Media: Error stopping video', error);
      }
    }
  }

  /**
   * Public method to stop media playback
   * Can be called from outside the component
   */
  stop() {
    this.stopMedia();
  }
});



/**
* ContentToggle Component
* Handles toggling between different content sections
* and manages media playback
*/
customElements.define('content-toggle', class ContentToggle extends BaseComponent {
  connectedCallback() {
    this.section = this.findClosest('section');
    if (!this.section) return;

    this.toggles = Array.from(this.section.querySelectorAll('content-toggle'));
    this.links = this.querySelectorAll('[data-toggle]');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.links.forEach(link => {
      this.addSafeEventListener(link, 'click', this.handleToggle);
    });
  }

  handleToggle = (event) => {
    event.preventDefault();

    const toggleIndex = parseInt(event.currentTarget.getAttribute('data-toggle'));
    const targetContent = this.toggles[toggleIndex];

    if (!targetContent) {
      console.warn('Content Toggle: Target content not found');
      return;
    }

    // Hide all content toggles and stop media in the section
    this.toggles.forEach((content) => {
      this.stopMediaInContent(content);
      this.toggleVisibility(content, false);
    });

    // Show the target content
    this.toggleVisibility(targetContent, true);

    // Update active states on toggle buttons
    this.updateActiveStates(event.currentTarget);
  }

  /**
   * Stops any playing media within a content element
   */
  stopMediaInContent(content) {
    const mediaElements = content.querySelectorAll('cjs-media');
    mediaElements.forEach(media => {
      if (typeof media.stop === 'function') {
        media.stop();
      }
    });
  }

  toggleVisibility(element, show) {
    element.classList.toggle('hidden', !show);
  }

  updateActiveStates(activeLink) {
    // Remove active state from all links
    this.links.forEach(link => {
      link.classList.remove('text-blue-600', 'border-blue-600', 'border-b-2');
    });

    // Add active state to clicked link
    activeLink.classList.add('text-blue-600', 'border-blue-600', 'border-b-2');
  }
});






/**
* CJSTextAnimate Component
* Animates through a list of words with smooth transitions
*/
customElements.define('cjs-text-animate', class CJSTextAnimate extends BaseComponent {
  constructor() {
    super();
    this.activeIndex = 0;
    this.animationInterval = null;
  }

  connectedCallback() {
    const wordsAttribute = this.getAttribute('data-words');
    if (!wordsAttribute) {
      console.warn('CJS Text Animate: No words provided in data-words attribute');
      return;
    }

    this.words = wordsAttribute.split(',').map(word => word.trim());
    if (this.words.length < 2) {
      console.warn('CJS Text Animate: At least 2 words are required for animation');
      return;
    }

    this.startAnimation();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.stopAnimation();
  }

  startAnimation() {
    // Initial render
    this.render();

    // Start the animation loop
    this.animationInterval = setInterval(() => {
      this.updateAnimation();
    }, 1000);
  }

  stopAnimation() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
      this.animationInterval = null;
    }
  }

  updateAnimation() {
    const nextIndex = (this.activeIndex + 1) % this.words.length;
    const upcomingIndex = (nextIndex + 1) % this.words.length;

    this.activeIndex = nextIndex;
    this.render(this.words[this.activeIndex], this.words[upcomingIndex]);
  }

  render() {
    const current = this.words[this.activeIndex];
    const next = this.words[(this.activeIndex + 1) % this.words.length];
    const upcoming = this.words[(this.activeIndex + 2) % this.words.length];

    const html = `
        <span class="animate-word animate-out">${current}</span>
        <span class="animate-word animate-in active">${next}</span>
        <span class="animate-word">${upcoming}</span>
      `;

    this.innerHTML = html;
  }


  updateWords(newWords) {
    this.stopAnimation();
    this.words = newWords.split(',').map(word => word.trim());
    this.activeIndex = 0;
    this.startAnimation();
  }
});




if (!customElements.get('turret-slider-snap')) {
  customElements.define('turret-slider-snap', class TurretSliderSnap extends HTMLElement {


    constructor() {
      super();
    }


    connectedCallback() {
      this.nextButton = this.querySelector('[data-next]');
      this.prevButton = this.querySelector('[data-prev]');

      this.track = this.querySelector('[data-track]');

      this.activeSlide = 0;


      this.slides = Array.from(this.querySelectorAll('[data-slide]'))
      this.sliderDots = Array.from(this.querySelectorAll('[data-dot]'))

      this.maxSlides = 0

      this.calculateMaxSlides();

      this.behavior = this.getAttribute('behavior') || 'smooth';

      if (this.nextButton) this.nextButton.addEventListener('click', this.next.bind(this));

      if (this.prevButton) this.prevButton.addEventListener('click', this.previous.bind(this));


      this.speed = this.getAttribute('speed') || 5000;

      this.autoplaySpeed = this.getAttribute('autoplay') || 0;

      this.autoplay = null;


      this.sliderDots.forEach((dot, index) => dot.addEventListener('click', this.move.bind(this, index)));

      this.track.addEventListener('scroll', () => this.updateUI.bind(this));


      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));


      this.updateUI();
    }



    calculateMaxSlides() {
      this.sliderDots.forEach((dot) => {
        const computed = window.getComputedStyle(dot).display
        if (computed != 'none') this.maxSlides++;
      })
    }



    move(slide) {

      if (!this.slides[slide]) return;

      if (slide > this.maxSlides - 1) return;

      const pos = this.track.clientWidth * slide;

      this.activeSlide = slide;

      this.track.scrollTo({
        left: pos,
        behavior: this.behavior
      });

      //this.track.scrollBy(this.slides[slide].clientWidth, 0)

      this.updateUI();
    }


    next(event) {
      event.preventDefault();

      this.move(this.activeSlide + 1);

    }

    previous(event) {
      event.preventDefault();

      this.move(this.activeSlide - 1);
    }


    canSlide() {
      const width = this.track.getBoundingClientRect().width
      if (width < 1) return 1;

      return (width / this.track.clientWidth) > this.activeSlide + 1
    }




    updateUI() {

      const next = this.slides[this.activeSlide + 1]
      const prev = this.slides[this.activeSlide - 1]

      const activeDot = this.sliderDots[this.activeSlide]

      const hasNext = (next !== undefined) && (this.activeSlide + 1) <= this.maxSlides - 1;

      if (this.nextButton) this.nextButton.classList.toggle('tt-opacity-100', hasNext)
      if (this.prevButton) this.prevButton.classList.toggle('tt-opacity-100', prev !== undefined)


      this.sliderDots.forEach((dot) => {
        dot.classList.toggle('tt-opacity-100', dot === activeDot);
      })
    }


    disconnectedCallback() {
      this.removeEventListener('mouseover', this.focusInHandling.bind(this));
      this.removeEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.pause();
    }


    shouldAutoplay() {
      return this.autoplaySpeed > 0
    }


    play() {

      if (!this.shouldAutoplay()) return;

      if (this.slides.length < 2) return;

      this.track.setAttribute('aria-live', 'off');


      this.autoplay = setInterval(() => {

        const slide = this.activeSlide === (this.slides.length - 1) ? 0 : this.activeSlide + 1

        this.move(slide);

      }, this.autoplaySpeed);
    }



    pause() {

      if (!this.shouldAutoplay()) return;

      this.track.setAttribute('aria-live', 'polite');


      clearInterval(this.autoplay);

    }

    focusOutHandling(event) {
      this.play();
    }

    focusInHandling(event) {
      this.pause();
    }


  })
}

customElements.define('collections-slider', class CollectionsSlider extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.sliders = this.querySelectorAll('.collectionsSlider');
    this.indexes = this.querySelectorAll('.collectionsIndex');
    this.indexSlider = this.querySelector('.indexSlider');

    if (this.sliders.length < 1 || this.indexes.length < 1) return;

    this.loadSliders(this.sliders);
    this.loadIndexSlider();

    this.indexes.forEach(index =>
      index.addEventListener('click', () => this.toggleCollectionSlider(index))
    );
  }


  loadSliders(sliders) {
    // Get the infinite scroll setting from the data attribute
    const infiniteScroll = this.dataset.infiniteScroll === 'true';
    
    sliders.forEach((el, i) => {
      if (!el.classList.contains('swiper-initialized')) {
        const totalSlides = el.querySelectorAll('.swiper-slide').length;

        // Only duplicate slides if infinite scroll is enabled and there are 4 or fewer slides
        if (infiniteScroll && totalSlides <= 4) {
          const fragment = document.createDocumentFragment();

          el.querySelectorAll('.swiper-slide').forEach(slide => {
            fragment.appendChild(slide.cloneNode(true));
          });

          el.querySelector('.swiper-wrapper').appendChild(fragment);
        }

        const nextEl = this.querySelector('.swiper-button-next');
        const prevEl = this.querySelector('.swiper-button-prev');
        
        new Swiper(el, {
          loop: infiniteScroll,
          slidesPerView: 1.7,
          spaceBetween: 16,
          grabCursor: true,
          navigation: { nextEl, prevEl },
          breakpoints: {
            1020: {
              slidesPerView: 4.2,
              spaceBetween: 22,
              centerInsufficientSlides: true,
            }
          },
          on: {
            init: () => {
              if (i === sliders.length - 1) {
                this.style.opacity = '1';
              }
            }
          }
        });
      }
    });
  }

  loadIndexSlider() {
    if (!this.indexSlider.classList.contains('swiper-initialized')) {
      new Swiper(this.indexSlider, {
        slidesPerView: 2.3,
        spaceBetween: 22,
        grabCursor: true,
        slideToClickedSlide: true,
        breakpoints: {
          1020: {
            slidesPerView: 4,
            spaceBetween: 50,
            width: 900,
            slideToClickedSlide: false,
            loop: false,
          }
        },
      });
    }
  }

  toggleCollectionSlider(index) {
    this.indexes.forEach(i => {
      i.classList.remove('text-chirp-blue');
      i.classList.add('text-chirp-gray-lightest');
    });

    index.classList.add('text-chirp-blue');
    index.classList.remove('text-chirp-gray-lightest');

    const activeSlider = this.querySelector('.collectionsSlider[active]');
    const newSlider = this.querySelector(`.collectionsSlider[data-index="${index.dataset.index}"]`);

    if (activeSlider) {
      activeSlider.removeAttribute('active');
      activeSlider.setAttribute('hidden', '');
    }

    newSlider.removeAttribute('hidden');
    newSlider.setAttribute('active', '');
  }
})

customElements.define('video-list-slider', class VideoListSlider extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = this.querySelector('.videoListSlider');

    if (!this.slider) return;

    this.loadSlider();
  }

  loadSlider() {
    if (this.slider.classList.contains('swiper-initialized')) return;

    const infiniteScroll = this.dataset.infiniteScroll === 'true';
    const nextEl = this.querySelector('.swiper-button-next');
    const prevEl = this.querySelector('.swiper-button-prev');
    const totalSlides = this.slider.querySelectorAll('.swiper-slide').length;

    // Let Swiper handle duplication internally with loop mode
    // Only enable loop if we have more than 1 slide
    new Swiper(this.slider, {
      loop: infiniteScroll && totalSlides > 1,
      slidesPerView: 1.2,
      spaceBetween: 16,
      grabCursor: true,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
      breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
        1020: {
          slidesPerView: 4.2,
          spaceBetween: 22,
          centerInsufficientSlides: true,
        }
      },
      on: {
        init: () => {
          this.style.opacity = '1';
        }
      }
    });
  }
})

customElements.define('product-gallery', class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    // Capture the pristine server-rendered slides before Swiper adds loop clones,
    // so variant filtering can always rebuild from a clean master.
    if (this.hasAttribute('data-variant-filter')) {
      const pristine = this.querySelector('.swiper-wrapper');
      if (pristine) this.viMaster = pristine.cloneNode(true);
    }

    this.loadSlider(this);

    const wrapper = this.querySelector('.swiper-wrapper');
    if (wrapper) {
      this.mobileHTML = wrapper.cloneNode(true);
    }

    this.checkAndLoadMedia();

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const desktopMediaJSON = document.querySelector('[data-desktop-media]');

    if (isDesktop && desktopMediaJSON) {
      try {
        const mediaData = JSON.parse(desktopMediaJSON.textContent);
        this.injectDesktopMedia(mediaData);
      } catch (error) {
        console.warn('Desktop media JSON malformed', error);
      }
    }
    this.addEventListeners();
    this.updatePauseButtonVisibility();

    if (this.hasAttribute('data-variant-filter')) {
      this.initVariantFilter();
    }

    window.addEventListener('resize', this.checkAndLoadMedia.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.checkAndLoadMedia.bind(this));
  }

  /* ---- Variant image A/B test (declarative, CSS-administered) -----------
     Gated by [data-variant-filter] on the <product-gallery> (rendered when
     the "Variant image thumbnails" setting is on) AND by the .chirp-vi-test
     class on <html> (added by the A/B tool or the ?variant-images-test=show
     demo param). CONTROL (class absent) = native gallery, untouched.

     The DECISION of what's visible lives entirely in CSS — it sets
     display:none on non-matching slides/thumbs based on the declarative
     [data-selected-color] attribute. This JS is generic plumbing only: it
     re-measures Swiper to whatever the CSS leaves visible. No color logic.
  ------------------------------------------------------------------------ */
  viRoot() {
    return this.closest('[data-vi-root]') || document.getElementById('main-product');
  }

  viTestActive() {
    return document.documentElement.classList.contains('chirp-vi-test');
  }

  initVariantFilter() {
    const self = this;
    this.initViController();

    if (!this.viMaster) {
      const wrapper = this.querySelector('.swiper-wrapper');
      if (wrapper) this.viMaster = wrapper.cloneNode(true);
    }
    // The mobile strip lives in a separate block from the mobile gallery, so
    // find the strip that matches this gallery's breakpoint within the root.
    const isDesktopGallery = !!this.closest('.lg\\:col-span-8');
    const root = this.viRoot();
    const stripSel = isDesktopGallery ? '.chirp-variant-thumbs--desktop' : '.chirp-variant-thumbs--mobile';
    this.thumbStrip = (root && root.querySelector(stripSel))
      || (this.parentElement && this.parentElement.querySelector('[data-variant-thumbs]'));
    this.bindThumbnails();

    if (this.viTestActive()) this.viActivate();

    // The A/B tool may add the class after load — activate when it appears.
    this._viHtmlObserver = new MutationObserver(function () {
      if (self.viTestActive()) self.viActivate();
    });
    this._viHtmlObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  viActivate() {
    if (this._viActive) return;
    this._viActive = true;
    const self = this;
    this.syncToVisible();

    // Re-measure whenever the declarative selected color changes.
    const root = this.viRoot();
    if (root) {
      this._viRootObserver = new MutationObserver(function () { self.syncToVisible(); });
      this._viRootObserver.observe(root, { attributes: true, attributeFilter: ['data-selected-color'] });
    }
  }

  // Generic: rebuild the carousel to exactly the slides the CSS leaves visible.
  syncToVisible() {
    if (!this._viActive || !this.viMaster) return;
    const wrapper = this.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    // 1. Restore the full server set so the CSS can decide what to hide.
    const full = this.viMaster.cloneNode(true);
    full.querySelectorAll('.swiper-slide-duplicate').forEach(function (d) { d.remove(); });
    full.removeAttribute('style');
    wrapper.replaceWith(full);

    // 2. Force layout so CSS display:none resolves, then drop hidden slides.
    void full.offsetHeight;
    const slides = Array.prototype.slice.call(full.querySelectorAll('.swiper-slide'));
    let kept = 0;
    slides.forEach(function (slide) {
      slide.removeAttribute('style');
      slide.classList.remove('swiper-slide-active', 'swiper-slide-prev', 'swiper-slide-next', 'swiper-slide-visible', 'swiper-slide-duplicate');
      if (window.getComputedStyle(slide).display === 'none') slide.remove();
      else kept++;
    });
    // Safety: never blank the gallery.
    if (kept === 0) {
      const fallback = this.viMaster.cloneNode(true);
      fallback.querySelectorAll('.swiper-slide-duplicate').forEach(function (d) { d.remove(); });
      full.replaceWith(fallback);
    }

    // 3. Re-init Swiper on the visible set.
    if (this.swiper) { try { this.swiper.destroy(true, true); } catch (e) { /* noop */ } this.swiper = null; }
    this.loadSlider(this);
    this.updateActiveThumb();
    this.playActiveVideo();
  }

  // After a variant swap the carousel resets to the first matching slide; if
  // that slide is a video, (re)start it from the beginning, muted.
  playActiveVideo() {
    const slide = this.getActiveSlide()
      || this.querySelector('.swiper-slide:not(.swiper-slide-duplicate)')
      || this.querySelector('.swiper-slide');
    const video = this.getVideoInSlide(slide);
    if (!video) return;
    try {
      video.muted = true;
      video.currentTime = 0;
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked */ });
    } catch (e) { /* noop */ }
  }

  // Page-level controller (runs once): mirrors swatch selection into the
  // declarative [data-selected-color] attribute and handles the demo param.
  initViController() {
    if (window.__chirpViController) return;
    window.__chirpViController = true;

    function slug(v) { return (v || '').trim().toLowerCase(); }
    function setSelected(color) {
      if (!color) return;
      document.querySelectorAll('[data-vi-root]').forEach(function (root) {
        root.setAttribute('data-selected-color', color);
      });
    }
    function currentColor() {
      const sel = document.querySelector('.chirp-color-swatch.selected');
      if (sel && sel.dataset.variantColor) return slug(sel.dataset.variantColor);
      const root = document.querySelector('[data-vi-root]');
      if (root && root.getAttribute('data-selected-color')) return root.getAttribute('data-selected-color');
      return '';
    }

    // ?variant-images-test=show turns the variant on for demos.
    try {
      const p = new URL(window.location.href).searchParams.get('variant-images-test');
      if (p === 'show' || p === '1' || p === 'true') document.documentElement.classList.add('chirp-vi-test');
    } catch (e) { /* noop */ }

    // Mirror swatch clicks into the declarative attribute.
    document.addEventListener('click', function (e) {
      const sw = e.target.closest && e.target.closest('.chirp-color-swatch');
      if (!sw || !sw.dataset.variantColor) return;
      const color = slug(sw.dataset.variantColor);
      setTimeout(function () { setSelected(color); }, 0);
    }, true);

    // Catch programmatic selection (e.g. the template's auto-select).
    const swObserver = new MutationObserver(function () {
      const c = currentColor();
      if (c) setSelected(c);
    });
    document.querySelectorAll('.chirp-color-swatch').forEach(function (sw) {
      swObserver.observe(sw, { attributes: true, attributeFilter: ['class'] });
    });

    setSelected(currentColor());
  }

  bindThumbnails() {
    if (!this.thumbStrip) return;
    const self = this;
    this.thumbStrip.querySelectorAll('.chirp-variant-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const index = parseInt(btn.getAttribute('data-thumb-index'), 10);
        self.goToOriginalIndex(index);
      });
    });
  }

  goToOriginalIndex(originalIndex) {
    if (!this.swiper) return;
    const realSlides = this.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
    for (let i = 0; i < realSlides.length; i++) {
      if (parseInt(realSlides[i].getAttribute('data-slide-index'), 10) === originalIndex) {
        if (typeof this.swiper.slideToLoop === 'function') this.swiper.slideToLoop(i);
        else this.swiper.slideTo(i);
        return;
      }
    }
  }

  updateActiveThumb() {
    if (!this.thumbStrip) return;
    const active = this.getActiveSlide();
    const activeIndex = active ? active.getAttribute('data-slide-index') : null;
    this.thumbStrip.querySelectorAll('.chirp-variant-thumb').forEach(function (btn) {
      const on = activeIndex !== null && btn.getAttribute('data-thumb-index') === activeIndex;
      btn.classList.toggle('chirp-variant-thumb--active', on);
    });
  }

  addEventListeners() {
    const pauseBtn = this.querySelector('[data-pause-chirp-video]');
    if (pauseBtn) {
      pauseBtn.addEventListener('click', () => this.toggleActiveVideo());
    }

    this.addEventListener('swiper-ready', () => {
      this.swiper.on('slideChangeTransitionEnd', () => {
        this.updatePauseButtonVisibility();
        this.updateActiveThumb();
      });
      this.swiper.on('resize', () => {
        this.updatePauseButtonVisibility();
      });
      this.updateActiveThumb();
    });
  }

  restoreMobileMedia() {
    if (!this.mobileHTML) return;
  
    const wrapper = this.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.replaceWith(this.mobileHTML.cloneNode(true));
    }
  
    if (this.swiper) {
      try { this.swiper.destroy(true, true); } catch {}
      this.swiper = null;
    }
  
    requestAnimationFrame(() => this.loadSlider(this));
  }  
  
  checkAndLoadMedia() {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const desktopMediaJSON = document.querySelector('[data-desktop-media]');

    if (isDesktop && desktopMediaJSON && !this.classList.contains('desktop-loaded')) {
      try {
        const mediaData = JSON.parse(desktopMediaJSON.textContent);
        this.injectDesktopMedia(mediaData);
        this.classList.add('desktop-loaded');
      } catch (error) {
        console.warn('Desktop media JSON malformed', error);
      }
    }

    if (!isDesktop && this.classList.contains('desktop-loaded')) {
      this.restoreMobileMedia();
      this.classList.remove('desktop-loaded');
      if (this.hasAttribute('data-variant-filter') && this._viActive) {
        var self = this;
        requestAnimationFrame(function () { self.syncToVisible(); });
      }
    }
  }

  getActiveSlide() {
    return this.querySelector('.swiper-slide.swiper-slide-active');
  }

  getVideoInSlide(slide) {
    if (!slide) return null;

    let video = slide.querySelector('video');
    if (video) return video;

    const vc = slide.querySelector('video-component');
    if (vc) {
      const inner = vc.querySelector('video');
      if (inner) return inner;
    }
    return null;
  }

  updatePauseButtonVisibility() {
    const pauseBtn = this.querySelector('[data-pause-chirp-video]');
    if (!pauseBtn) return;

    const slide = this.getActiveSlide();
    const video = this.getVideoInSlide(slide);

    if (video) {
      pauseBtn.classList.add('is-visible');
    } else {
      pauseBtn.classList.remove('is-visible');
    }
  }

  toggleActiveVideo() {
    const slide = this.getActiveSlide();
    const video = this.getVideoInSlide(slide);
    if (!video) return;

    const playBtn = this.querySelector("[data-play-chirp]");
    const pauseBtn = this.querySelector("[data-pause-chirp]");

    if (!playBtn || !pauseBtn) return;

    if (video.paused) {
      video.play().catch(() => { });
    } else {
      video.pause();
    }

    const isPlaying = !video.paused;
    pauseBtn.classList.toggle('hidden', !isPlaying);
    playBtn.classList.toggle('hidden', isPlaying);

  }

  injectDesktopMedia(mediaArray) {
    const wrapper = this.querySelector('.swiper-wrapper');
    if (!wrapper || !mediaArray?.length) return;
  
    const frag = document.createDocumentFragment();
  
    mediaArray.forEach((media, i) => {
      const fetchPriority = i === 0 ? 'high' : 'auto';
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
  
      const mediaWrap = document.createElement('div');
      mediaWrap.className = 'media-wrap w-full h-full flex items-center justify-center';
  
      if (media && media.media_type === 'video') {
        const videoComponent = document.createElement('video-component');
        videoComponent.className = 'relative h-full w-full block';
  
        const videoEl = document.createElement('video');
        videoEl.className = 'cjs-media__video h-full w-auto max-h-full max-w-full object-cover object-center';
        videoEl.autoplay = true;
        videoEl.muted = true;
        videoEl.loop = true;
        videoEl.controls = false;
        videoEl.playsInline = true;
        videoEl.setAttribute('fetchpriority', fetchPriority);
  
        if (media.preview_image?.src) {
          videoEl.poster = media.preview_image.src.replace(/^\/\//, 'https://');
        }
  
        if (Array.isArray(media.sources) && media.sources.length) {
          media.sources.forEach(s => {
            const src = document.createElement('source');
            src.src = (s.url || '').replace(/^\/\//, 'https://');
            if (s.mime_type) src.type = s.mime_type;
            videoEl.appendChild(src);
          });
        }
  
        videoComponent.appendChild(videoEl);
  
        const controls = document.createElement('div');
        controls.className = 'video-controls hidden';
  
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'toggle-play size-6 lg:size-7 rounded-full items-center justify-center p-1';
        btn.setAttribute('aria-label', 'Toggle Play state of the video');
        btn.setAttribute('data-video-toggle', '');
  
        const tpl = document.getElementById('video-icons-template');
        if (tpl && tpl.content) {
          btn.appendChild(tpl.content.cloneNode(true));
        }
  
        controls.appendChild(btn);
        videoComponent.appendChild(controls);
        mediaWrap.appendChild(videoComponent);
  
      } else if (typeof media === 'string') {
        const img = document.createElement('img');
        img.src = media.replace(/^\/\//, 'https://');
        img.alt = '';
        img.className = 'h-full w-full max-w-screen max-h-full object-cover object-center';
        img.setAttribute('fetchpriority', fetchPriority);
        mediaWrap.appendChild(img);
      }
  
      slide.appendChild(mediaWrap);
      frag.appendChild(slide);
    });
  
    wrapper.replaceChildren(frag);
  
    this.classList.remove('loading');
    this.classList.add('loaded');
  
    // Re-init swiper
    if (this.swiper) {
      try {
        this.swiper.destroy(true, true);
      } catch (err) {
        console.warn('Error destroying swiper', err);
      }
      this.swiper = null;
    }
  
    requestAnimationFrame(() => this.loadSlider(this));
  }

  loadSlider(slider) {
    if (slider.classList.contains('swiper-initialized')) return;
  
    const nextEl = slider.querySelector('.swiper-button-next');
    const prevEl = slider.querySelector('.swiper-button-prev');
    const paginationEl = slider.querySelector('.swiper-pagination');
  
    const config = {
      slidesPerView: 1,
      grabCursor: true,
      loop: true,
      on: {
        init: () => {
          this.dispatchEvent(new CustomEvent('swiper-ready', { bubbles: true }));
        },
        slideChangeTransitionEnd: () => this.updatePauseButtonVisibility(),
      },
    };
  
    if (nextEl && prevEl) {
      config.navigation = { nextEl, prevEl };
    }
  
    if (paginationEl) {
      config.pagination = { el: paginationEl, clickable: true };
    }
  
    this.swiper = new Swiper(slider, config);
  }  
});

/**
 * Sticky CTA Component
 * - Shows a fixed CTA at the bottom on mobile when the original CTA is not visible
 * - Mirrors the original product form button (text, disabled state, style)
 * - On click, submits the original form (so all logic remains centralized)
 */
customElements.define('sticky-cta', class StickyCta extends BaseComponent {
  constructor() {
    super();
    this.section = null;
    this.form = null;
    this.originalButton = null;
    this.stickyButton = null;
    this.intersectionObserver = null;
    this.mutationObserver = null;
    this.mediaQuery = window.matchMedia('(max-width: 1023px)');
    this.isVisible = false;
    this.hasScrolled = false;
    this.minScrollDistance = 500;
  }

  connectedCallback() {
    // Host base styles
    this.style.position = 'fixed';
    this.style.left = '0';
    this.style.right = '0';
    this.style.bottom = '0';
    this.style.zIndex = '30';
    this.style.display = 'none';
    this.style.pointerEvents = 'none';

    // Create inner container and button
    this.innerHTML = '';
    const wrapper = document.createElement('div');
    wrapper.style.background = 'transparent';
    wrapper.style.padding = '12px 16px';
    wrapper.style.paddingBottom = 'calc(12px + env(safe-area-inset-bottom))';
    wrapper.style.width = '100%';
    wrapper.style.pointerEvents = 'auto';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn-primary w-full';
    btn.setAttribute('aria-label', 'Add to cart');
    btn.textContent = 'Add to cart';
    wrapper.appendChild(btn);
    this.appendChild(wrapper);

    this.stickyButton = btn;
    this.addSafeEventListener(this.stickyButton, 'click', this.onStickyClick);

    this.mediaQuery.addEventListener('change', () => this.updateVisibility());
    
    // Track scroll position to ensure user has actually scrolled
    this.addSafeEventListener(window, 'scroll', debounce(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.hasScrolled = scrollTop >= this.minScrollDistance;
      this.updateVisibility();
    }, 50));

    // Locate original form/button inside same section
    this.section = this.closest('section') || document;
    this.form = this.section.querySelector('product-form form');
    this.originalButton = this.form ? this.form.querySelector('button[type="submit"]') : null;

    if (!this.form || !this.originalButton) {
      this.log('Sticky CTA: form or button not found in section', null, 'warn');
      return;
    }

    // Mirror initial state
    this.syncFromOriginal();

    // Observe visibility of original button
    this.intersectionObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const buttonInView = !!entry?.isIntersecting;
      // Only show sticky CTA when button is out of view AND user has scrolled down
      this.setActive(this.mediaQuery.matches && !buttonInView && this.hasScrolled);
    }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });
    this.intersectionObserver.observe(this.originalButton);

    // Footer observer removed - we use padding instead of hiding the button

    // Observe changes in the original button (text/disabled/style)
    this.mutationObserver = new MutationObserver(() => this.syncFromOriginal());
    this.mutationObserver.observe(this.originalButton, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
      childList: true,
      subtree: true,
    });

    // Re-sync on resize (class changes may occur)
    this.addSafeEventListener(window, 'resize', debounce(() => this.syncFromOriginal(), 150));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.intersectionObserver) this.intersectionObserver.disconnect();
    if (this.mutationObserver) this.mutationObserver.disconnect();
  }

  onStickyClick() {
    if (!this.form) return;
    try {
      // Submit the original form so all existing logic runs
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
      } else {
        const evt = new Event('submit', { bubbles: true, cancelable: true });
        this.form.dispatchEvent(evt);
      }
    } catch (e) {
      console.warn('Sticky CTA: submit fallback', e);
      this.form.submit();
    }
  }

  syncFromOriginal() {
    if (!this.originalButton || !this.stickyButton) return;

    // Copy text (including nested spans)
    this.stickyButton.innerHTML = this.originalButton.innerHTML;

    // Copy relevant classes, ensure full width, but replace outlined style with solid for sticky
    const classesToCopy = Array.from(this.originalButton.classList)
      .filter(c => c.startsWith('btn'))
      .map(c => c === 'btn-secondary-outlined' ? 'btn-secondary' : c);
    const base = ['w-full'];
    this.stickyButton.className = [...classesToCopy, ...base].join(' ') || 'btn btn-primary w-full';

    // Disabled state mirrors original
    this.stickyButton.disabled = this.originalButton.disabled;
  }

  setActive(active) {
    if (this.isVisible === active) return;
    this.isVisible = active;
    this.style.display = active ? 'block' : 'none';

    // Add/remove body padding to prevent footer blocking (only on contour-v2 template)
    const isContourTemplate = document.body.dataset.template?.includes('contour-v2');
    if (isContourTemplate) {
      const footer = document.querySelector('footer');
      if (footer) {
        if (active) {
          footer.style.paddingBottom = '80px';
        } else {
          footer.style.paddingBottom = '';
        }
      }
    }
  }

  updateVisibility() {
    if (!this.originalButton) {
      this.setActive(false);
      return;
    }
    // If on desktop, always hide
    if (!this.mediaQuery.matches) {
      this.setActive(false);
      return;
    }
    // If user hasn't scrolled enough, hide sticky CTA
    if (!this.hasScrolled) {
      this.setActive(false);
      return;
    }
    // Force a check using bounding rect as a fallback
    const rect = this.originalButton.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const inView = rect.top < vh && rect.bottom > 0;
    this.setActive(!inView);
  }
});

customElements.define('cards-slider', class CardsSlider extends HTMLElement {
  constructor() {
    super();
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onResize = this._onResize.bind(this);
    this.cardsSwiper = null;
  }

  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('.cardModal'));
    this.modal = this.querySelector('#cardsModal');
    this.closeBtn = this.querySelectorAll('.closeCardsModal');
    this.expandedSwiperEl = this.querySelector('.expandedSwiper');
    this.cardsSlider = this.querySelector('.cardsSlider');

    this._preloadFirstSlideImage();

    if (typeof Swiper !== 'undefined' && this.expandedSwiperEl) {
      this._initSwiper();       // modal swiper
      // this._initCardsSlider();
    }

    this.cards.forEach((card, idx) => {
      card.addEventListener('click', () => {
        if (window.innerWidth >= 1024) {
          this.toggleInline(idx);
        } else {
          const i = parseInt(card.dataset.index, 10) || 0;
          this.openModal(i);
        }
      });

      this.openCloseBtn(card, idx);
    });

    if (this.closeBtn) {
      this.closeBtn.forEach(btn => {
        btn.addEventListener('click', () => this.closeModal());
      });
    }

    if (this.modal) {
      this.modal.addEventListener('click', e => {
        if (e.target === this.modal) this.closeModal();
      });
    }

    document.addEventListener('keydown', this._onKeyDown);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onKeyDown);
    window.removeEventListener('resize', this._onResize);
  }

  _onResize() {
    // this._initCardsSlider();
    this.cards.forEach((card, idx) => this.openCloseBtn(card, idx));
  }

  openCloseBtn(card, idx) {
    const closeInline = card.querySelector('.closeInline');
    if (!closeInline) return;
  
    if (closeInline._handler) {
      closeInline.removeEventListener('click', closeInline._handler);
    }
  
    closeInline._handler = (e) => {
      e.stopPropagation();
  
      if (window.innerWidth < 1024) {
        const i = parseInt(card.dataset.index, 10) || 0;
        this.openModal(i);
      } else {
        this.toggleInline(idx);
      }
    };
  
    closeInline.addEventListener('click', closeInline._handler);
  }  

  _initSwiper() {
    const pagination = this.modal.querySelector('.swiper-pagination');
    const nextEl = this.modal.querySelector('.swiper-button-next');
    const prevEl = this.modal.querySelector('.swiper-button-prev');

    this.swiper = new Swiper(this.expandedSwiperEl, {
      loop: false,
      slidesPerView: 1,      
      centeredSlides: true,
      pagination: { el: pagination, clickable: true },
      navigation: { nextEl, prevEl },
      grabCursor: true,
      keyboard: { enabled: true },
    });
  }

  _initCardsSlider() {
    const isMobile = window.innerWidth < 1024;

    // Mobile Slider
    if (isMobile) {
      if (!this.cardsSwiper) {
        const pagination = this.cardsSlider.querySelector('.swiper-pagination');
        const nextEl = this.cardsSlider.querySelector('.swiper-button-next');
        const prevEl = this.cardsSlider.querySelector('.swiper-button-prev');

        this.cardsSwiper = new Swiper(this.cardsSlider, {
          slidesPerView: 1.1,
          spaceBetween: 22,
          pagination: { el: pagination, clickable: true },
          navigation: { nextEl, prevEl },
          grabCursor: true,
          keyboard: { enabled: true },
        });
      }
    } 
    else {
      if (this.cardsSwiper) {
        this.cardsSwiper.destroy(true, true);
        this.cardsSwiper = null;
      }
    }
  }

  _preloadFirstSlideImage() {
    const firstSlideImg = this.querySelector('.swiper-slide img');
    if (firstSlideImg && !firstSlideImg.complete) {
      const img = new Image();
      img.src = firstSlideImg.src || firstSlideImg.dataset.src;
    }
  }

  toggleInline(index) {
    const card = this.cards[index];
    if (!card) return;
  
    const container = this.cardsSlider?.querySelector('.cards-row');
    const wasExpanded = card.classList.contains('expanded');
    const noneExpanded = !this.cards.some(c => c.classList.contains('expanded'));
  
    this.cards.forEach(c => c.classList.remove('expanded'));
  
    if (!wasExpanded) {
      if (container) {
        container.style.scrollSnapType = 'none';
        container.style.webkitScrollSnapType = 'none';
      }
  
      card.classList.add('expanded');
  
      // Read the actual transition duration from CSS
      const styles = getComputedStyle(card);
      const duration = parseFloat(styles.transitionDuration) || 0;
      const delay = parseFloat(styles.transitionDelay) || 0;
      const totalTime = (duration + delay) * 1000;
  
      // Measure near the end (90% of transition duration)
      const measureTime = totalTime * 0.9;
  
      // Fallback: if transitionDuration is 0, measure next frame
      if (measureTime > 0) {
        setTimeout(() => {
          this._scrollCardPrecisely(card, index, noneExpanded);
        }, measureTime);
      } else {
        requestAnimationFrame(() => {
          this._scrollCardPrecisely(card, index, noneExpanded);
        });
      }
  
      const onTransitionEnd = (e) => {
        if (e.propertyName === 'width' || e.propertyName === 'max-width') {
          card.removeEventListener('transitionend', onTransitionEnd);
          if (container) {
            container.style.scrollSnapType = 'x mandatory';
            container.style.webkitScrollSnapType = 'x mandatory';
          }
        }
      };
      card.addEventListener('transitionend', onTransitionEnd, { once: true });
  
    } else {
      if (container) {
        container.style.scrollSnapType = 'x mandatory';
        container.style.webkitScrollSnapType = 'x mandatory';
      }
    }
  }  
  
  _scrollCardPrecisely(card, index, noneExpanded) {
    const container = this.cardsSlider?.querySelector('.cards-row');
    if (!container) return;
  
    const containerRect = container.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();
  
    const futureWidth = window.innerWidth * (window.innerWidth >= 2048 ? 0.45 : 0.55);
    const cardLeftInContainer = (cardRect.left - containerRect.left) + container.scrollLeft;
    const containerWidth = container.clientWidth;
  
    const cs = getComputedStyle(container);
    const padL = parseInt(cs.scrollPaddingLeft || '0', 10);
    const padR = parseInt(cs.scrollPaddingRight || '0', 10);
  
    let targetScrollLeft;
    if (index === 0) {
      targetScrollLeft = cardLeftInContainer - padL;
    } else if (index === this.cards.length - 1) {
      targetScrollLeft = (cardLeftInContainer + futureWidth) - containerWidth + padR;
    } else {
      targetScrollLeft = cardLeftInContainer + (futureWidth / 2) - (containerWidth / 2);
    }
  
    const maxScroll = container.scrollWidth - containerWidth;
    targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScroll));
  
    console.log(
      'cardLeftInContainer:', cardLeftInContainer,
      'futureWidth:', futureWidth,
      'target:', targetScrollLeft,
      'containerWidth:', containerWidth,
      'index', index,
      'noneExpanded', noneExpanded
    );
  
    container.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
  }  

  openModal(index = 0) {
    this.modal.classList.remove('hidden');
    setTimeout(() => {
      if (this.swiper) {
        this.swiper.update();
        this.swiper.slideTo(index, 0);
      }
    }, 0);
    requestAnimationFrame(() => {
      document.body.classList.add('modal-open');
      requestAnimationFrame(() => {
        if (this.swiper) {
          this.swiper.update();
          this.swiper.slideTo(index, 0);
        }
      });
    });
  }

  closeModal() {
    document.body.classList.remove('modal-open');
    this.modal.classList.add('hidden');
  }

  _onKeyDown(e) {
    if (e.key === 'Escape') {
      if (window.innerWidth >= 1024) {
        this.cards.forEach(c => c.classList.remove('expanded'));
      } else {
        this.closeModal();
      }
    }
  }
});

customElements.define('video-slider', class VideoSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.applySlideState();
    if (!this.swiper) {
      this.initSwiper();
    }
  }

  initSwiper() {
    const nextEl = this.querySelector('.swiper-button-next');
    const prevEl = this.querySelector('.swiper-button-prev');

    this.swiper = new Swiper(this, {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      coverflowEffect: {
        rotate: 0,
        stretch: "90%",
        depth: 72,
        modifier: 1,
        slideShadows: false,
      },
      navigation: { nextEl, prevEl },
      breakpoints: {
        1024: { coverflowEffect: { stretch: "86%", depth: 75 } },
        1440: { coverflowEffect: { stretch: "82%", depth: 80 } },
        1800: { coverflowEffect: { stretch: "80%", depth: 82 } }
      },
      on: {
        init: () => this.applyInitialState(),
        slideChange: () => this.applySlideState(),
        slideChangeTransitionEnd: () => this.applySlideState(),
      },
    });
  }
  

  applyInitialState() {
    const slides = this.querySelectorAll('.swiper-slide');

    slides.forEach(slide => {
      slide.addEventListener('video-loaded', () => {
        const isActive = slide.classList.contains('swiper-slide-active');
        slide.classList.toggle('scale-100', isActive);
        slide.classList.toggle('scale-95', !isActive);
  
        const overlay = slide.querySelector('.overlay');
        const video = slide.querySelector('video');
        const playSVG = slide.querySelector('[data-play-svg]');
        const pauseSVG = slide.querySelector('[data-pause-svg]');
  
        if (playSVG && pauseSVG) {
          playSVG.classList.remove('hidden');
          pauseSVG.classList.add('hidden');
        }
    
        // Overlay hides only if active AND video is playing
        if (overlay) {
          const shouldHideOverlay = isActive && video;
          overlay.classList.toggle('opacity-0', shouldHideOverlay);
          overlay.classList.toggle('opacity-100', !shouldHideOverlay);
        }
      });
    });    
  }

  applySlideState() {
    const slides = this.querySelectorAll('.swiper-slide');
    const activeIndex = this.swiper?.activeIndex;

    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.classList.toggle('scale-100', isActive);
      slide.classList.toggle('scale-95', !isActive);

      const overlay = slide.querySelector('.overlay');
      const video = slide.querySelector('video');
      const playSVG = slide.querySelector('[data-play-svg]');
      const pauseSVG = slide.querySelector('[data-pause-svg]');
  
      // Pause and reset buttons for inactive slides
      if (video && !video.paused) {
        video.pause();
        if (playSVG && pauseSVG) {
          playSVG.classList.remove('hidden');
          pauseSVG.classList.add('hidden');
        }
      }

      // Overlay hides only if active AND video is playing
      if (overlay) {
        const shouldHideOverlay = isActive && video;
        overlay.classList.toggle('opacity-0', shouldHideOverlay);
        overlay.classList.toggle('opacity-100', !shouldHideOverlay);
      }      
    });
  }
});

customElements.define('closer-look-new', class extends HTMLElement {
  constructor() {
    super();
    this.toggleInput = this.querySelector('#closer-look-toggle');
    this.mobileImages = this.querySelectorAll('.mobile-image');
    this.desktopImages = this.querySelectorAll('.desktop-image');
    this.handleToggleChange = this.handleToggleChange.bind(this);
    this.tooltips = this.querySelectorAll('.pin');
    this.containerPins = this.querySelectorAll(".tool--tip-container");
  }

  connectedCallback() {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    if (this.toggleInput) {
      this.toggleInput.addEventListener('change', this.handleToggleChange);
    }
    this.render(0);
    this.setRotation();

    if (isDesktop) this.setHover();
  }

  handleToggleChange(e) {
    const idx = e.target.checked ? 1 : 0;
    this.render(idx);
    // this.closeAllTooltips();
  }

  setRotation() {
    this.tooltips.forEach(pin => {
      const tooltip = pin.nextElementSibling;
      if (!tooltip) return;
  
      pin.addEventListener('click', (e) => {
        e.stopPropagation();

        // Mobile: only allow one tooltip open at a time
        if (!window.matchMedia('(min-width: 768px)').matches) {
          const wasVisible = tooltip.classList.contains('visible');
          this.closeAllTooltips();

          if (!wasVisible) {
            tooltip.classList.add('visible');
            pin.classList.add('rotated');
          }
          return;
        }

        // Desktop: preserve existing toggle behavior (hover is handled separately)
        tooltip.classList.toggle('visible');
        pin.classList.toggle('rotated', tooltip.classList.contains('visible'));
      });
    });
  
    // Optional: Tap anywhere outside to close all (still works)
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.closeAllTooltips();
      }
    });
  }

  setHover() {
    this.containerPins.forEach(container => {
      const pin = container.querySelector(".pin");
      const tooltip = container.querySelector(".tooltip");
      if (!pin || !tooltip) return;
  
      const show = () => {
        void tooltip.offsetWidth;
        tooltip.classList.add('visible');
        pin.classList.add('rotated');
      };
  
      const hide = () => {
        tooltip.classList.remove('visible');
        pin.classList.remove('rotated');
      };
  
      pin.addEventListener('mouseenter', show);
      pin.addEventListener('mouseleave', hide);
      tooltip.addEventListener('mouseenter', show);
      tooltip.addEventListener('mouseleave', hide);
    });
  }

  render(activeIndex = 0) {
    const updateVisibility = (elements) => {
      elements.forEach((el, i) => {
        const isActive = i === activeIndex;
  
        if (isActive) {
          el.hidden = false;
          requestAnimationFrame(() => el.classList.add("active"));
        } else {
          el.classList.remove("active");
          el.addEventListener("transitionend", () => {
            if (!el.classList.contains("active")) {
              el.hidden = true;
            }
          }, { once: true });
        }
      });
    };
  
    updateVisibility(this.mobileImages);
    updateVisibility(this.desktopImages);
  }  

  closeAllTooltips() {
    this.querySelectorAll('.tooltip.visible').forEach(t => t.classList.remove('visible'));
    this.tooltips.forEach(btn => btn.classList.remove('rotated'));
  }
});

class ChirpHeader extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
    // this.updateContrast = this.updateContrast.bind(this);
    this.defaultLogo = null;
    this.altLogo = null;
    this.txtLogo = null;
    this.menuToggle = null;
    this.chatBtn = null;
    this.gladlyBtn = null;
    this.isLightHeader = this.classList.contains('header--light');
  }

  connectedCallback() {
    this.defaultLogo = this.querySelector('.site-logo--default');
    this.altLogo = this.querySelector('.site-logo--alt');
    this.txtLogo = this.querySelector('.site-logo--txt');

    this.handleMenu();
    // this.updateContrast();

    // Initialize light header with alt logo visible
    if (this.isLightHeader) {
      if (this.defaultLogo) this.defaultLogo.classList.add('hidden');
      if (this.altLogo) this.altLogo.classList.remove('hidden');
      if (this.txtLogo) this.txtLogo.classList.add('hidden');
    }    

    if (window.scrollY > 0 && !this.classList.contains('header--scrolled')) this.classList.add('header--scrolled');

    window.addEventListener('scroll', this._onScroll, { passive: true });
    // window.addEventListener('resize', this.updateContrast);
    // window.addEventListener('load', this.updateContrast);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    // window.removeEventListener('resize', this.updateContrast);
    // window.removeEventListener('load', this.updateContrast);
  }

  handleMenu() {
    this.menuToggle = this.querySelector('#mobile-menu');
    this.chatBtn = this.querySelector('#chat-trigger');

    if (!this.menuToggle || !this.chatBtn) return;

    this.menuToggle.addEventListener('click', (e) => {
      // const hasMenuOpened = e.currentTarget.getAttribute('aria-expanded');
      // console.log('menu opened?', hasMenuOpened);
      const gladlyBtn = document.querySelector('.minimizedChatButtonSelector.minimizedChatButton');
      gladlyBtn.classList.toggle('invisible');
    });

    this.chatBtn.addEventListener('click', () => {
      const gladlyBtn = document.querySelector('.minimizedChatButtonSelector.minimizedChatButton');
      gladlyBtn.click();
    });
  }

  _onScroll() {
    // this.updateContrast();

    const scrolled = window.scrollY > 0;
    const currentScrollY = window.scrollY;
    const hasMenuOpened = this.querySelector('#mobile-menu')?.getAttribute('aria-expanded');
  
    // For light headers, only handle scroll state, don't change logos
    if (this.isLightHeader) {
      this.classList.toggle('header--scrolled', scrolled);
      
      // Handle header hide/show on scroll down (only for light headers if needed)
      if (currentScrollY > this.lastScrollY && currentScrollY > 100 && hasMenuOpened === 'false') {
        this.classList.add('header--hidden');
      } else {
        this.classList.remove('header--hidden');
      }
      
      this.lastScrollY = currentScrollY;
      return;
    }
  
    // For transparent headers (default), handle logo switching on scroll
    this.classList.toggle('header--scrolled', scrolled);
  
    if (!(this.defaultLogo && this.altLogo && this.txtLogo)) {
      this.lastScrollY = currentScrollY;
      return;
    }
  
    // Switch logos on scroll for transparent header
    this.defaultLogo.classList.add('hidden');
    this.altLogo.classList.add('hidden');
    this.txtLogo.classList.add('hidden');
  
    if (scrolled) {
      this.txtLogo.classList.remove('hidden');
    } else {
      this.defaultLogo.classList.remove('hidden');
    }

    // Handle header hide/show on scroll down
    if (currentScrollY > this.lastScrollY && currentScrollY > 100 && hasMenuOpened === 'false') {
      this.classList.add('header--hidden');
    } else {
      this.classList.remove('header--hidden');
    }

    this.lastScrollY = currentScrollY;
  }

  isDark(color, el) {
    if (!color) return false;
    const [r, g, b] = color.match(/\d+/g).map(Number);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 200;
  }

  getSolidBackgroundColor(el) {
    while (el && el !== document.documentElement) {
      const bg = getComputedStyle(el).backgroundColor;
      if (bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
        return bg;
      }
      el = el.parentElement;
    }
    return 'rgb(255,255,255)';
  }

  updateContrast() {
    const rect = this.getBoundingClientRect();
    const y = rect.bottom + 1;
    const x = window.innerWidth / 2;

    const elBelow = document.elementFromPoint(x, y);
    if (!elBelow) return;

    const bgColor = this.getSolidBackgroundColor(elBelow);
    const dark = this.isDark(bgColor, elBelow);

    if (dark) {
      this.classList.remove('inverted');
    } else {
      this.classList.add('inverted');
    }
  }
}

customElements.define('chirp-header', ChirpHeader);

(function () {
  let ticking = false;

  function updateParallax() {
    document.querySelectorAll(".cjs-parallax-container").forEach(container => {
      const images = container.querySelectorAll(".cjs-parallax-image");
      if (!images.length) return;

      const rect = container.getBoundingClientRect();

      // how far through the viewport the element is, 0 = just entering, 1 = fully left
      let progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      progress = Math.min(Math.max(progress, 0), 1);

      images.forEach(img => {
        const overflow = img.offsetHeight - container.offsetHeight;

        // map progress (0→1) to offset (-overflow/2 → +overflow/2)
        let offset = (progress - 0.5) * overflow;

        img.style.setProperty("--parallax-offset", offset + "px");
      });
    });

    ticking = false;
  }

  document.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  });

  window.addEventListener("resize", updateParallax);
  window.addEventListener("load", updateParallax);
})();

// MAI Checkout Tracking - Detects navigation to checkout
(function() {
  let checkoutTracked = false;
  let checkoutEventData = null;
  let userInitiatedCheckout = false;
  
  function trackCheckoutStart() {
    if (checkoutTracked) return;
    if (typeof MAI === 'undefined') return;
    
    // Use cached data if available (for immediate navigation scenarios)
    if (checkoutEventData) {
      MAI.emit('checkout', checkoutEventData.total, checkoutEventData.currency, checkoutEventData.details);
      checkoutTracked = true;
      return;
    }
    
    // Get cart data from Shopify's global cart object
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const lineItems = cart.items.map(item => ({
          quantity: item.quantity,
          productId: String(item.product_id),
          productName: item.product_title,
          productType: item.product_type,
          productVendor: item.vendor,
          variantId: String(item.variant_id),
          variantName: item.variant_title
        }));

        MAI.emit('checkout', cart.total_price / 100, cart.currency, {
          id: "cart_" + Date.now(),
          quantity: cart.item_count,
          lineItems: lineItems
        });
        
        checkoutTracked = true;
      })
      .catch(error => console.error('MAI checkout tracking error:', error));
  }
  
  // Pre-fetch cart data when cart drawer opens to avoid race conditions
  function prefetchCartData() {
    if (checkoutEventData) return; // Already cached
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const lineItems = cart.items.map(item => ({
          quantity: item.quantity,
          productId: String(item.product_id),
          productName: item.product_title,
          productType: item.product_type,
          productVendor: item.vendor,
          variantId: String(item.variant_id),
          variantName: item.variant_title
        }));

        checkoutEventData = {
          total: cart.total_price / 100,
          currency: cart.currency,
          details: {
            id: "cart_" + Date.now(),
            quantity: cart.item_count,
            lineItems: lineItems
          }
        };
      })
      .catch(error => console.error('MAI cart prefetch error:', error));
  }
  
  // Make trackCheckoutStart globally available for inline onclick
  window.trackCheckoutStart = trackCheckoutStart;
  
  // Watch for cart drawer opening to pre-fetch data
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // Check if drawer opened or Redo element appeared
          if (node.querySelector && (node.querySelector('drawer-component') || node.querySelector('redo-shopify-toggle'))) {
            prefetchCartData();
          }
        }
      });
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Also pre-fetch when cart is updated
  document.addEventListener('cart:updated', prefetchCartData);
  
  // Primary strategy: Intercept mousedown on Redo element
  document.addEventListener('mousedown', function(event) {
    const redoElement = event.target.closest('redo-shopify-toggle');
    if (redoElement) {
      userInitiatedCheckout = true;
      trackCheckoutStart();
    }
  }, true);
  
  // Fallback: Standard checkout button (for non-Redo scenarios)
  document.addEventListener('click', function(event) {
    const checkoutButton = event.target.closest('[id="checkout"], [name="checkout"], .checkout-button');
    if (checkoutButton) {
      userInitiatedCheckout = true;
      trackCheckoutStart();
    }
  }, true);
  
  // Safety net: Only fire on navigation if user actually clicked checkout
  window.addEventListener('pagehide', function(e) {
    if (!checkoutTracked && userInitiatedCheckout) {
      trackCheckoutStart();
    }
  });
  
})();
